import { render, staticRenderFns } from "./VpsPartial.vue?vue&type=template&id=45a20c33&"
import script from "./VpsPartial.vue?vue&type=script&lang=js&"
export * from "./VpsPartial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports